export let allWords = [];

export function setAllWords(value) {
  allWords = value
}

